var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"panel-group",attrs:{"gutter":40}},[_c('a-col',{staticClass:"card-panel-col",attrs:{"xs":12,"sm":12,"lg":6}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }